/**
 * External dependencies
 */
import inherits from 'inherits';

export default class Invoice {
    
    constructor(cscom) {
        if (!(this instanceof Invoice)) {
            return new Invoice(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/invoices/list', null, data);
    }

    downloadInvoice(invoiceId) {
        return this.cscom.req.get('/customer-site-api/invoices/' + invoiceId + '/download', null);
    }
}
